export default __webpack_public_path__ + "static/media/react-native-svg.fad73e03.png";